import { InjectionToken, Signal } from '@angular/core';
import { EventDetailsVM } from '@libs/store';

export const EVENT_DETAILS_SIDEBAR_EVENT = new InjectionToken<Signal<EventDetailsVM | undefined>>('EVENT_DETAILS_SIDEBAR_EVENT');
